// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"767881da054ccfb515b2","5841":"2956cf90692725214f3d"}[chunkId] + ".css";
};